export enum ThemeType {
  'THEME_DARK' = 'dark',
  'THEME_BRIGHT' = 'bright'
}
export const themeColor = {
  dark: {
    'main-bg-color': '#12131A',
    'block-bg-color': 'rgba(255, 255, 255, 0.04)',
    'border-color': 'rgba(255, 255, 255, 0.05)',
    'progress-color': 'rgba(255, 255, 255, 0.01)',
    'scroll-color': 'rgba(255, 255, 255, 0.5)', 
    'thead-bg-color': 'rgba(255, 255, 255, 0.05)',
    'menu-bg-color': '#27282E',
    'main-font-color': '#fff',
    'font-color-08': 'rgba(255, 255, 255, 0.8)',
    'font-color-06': 'rgba(255, 255, 255, 0.6)',
    'font-color-04': 'rgba(255, 255, 255, 0.4)',
    'font-color-02': 'rgba(255, 255, 255, 0.2)'
  },
  bright: {
    'main-bg-color': '#F7F8FA',
    'block-bg-color': '#fff',
    'progress-color': 'rgba(0, 0, 0, 0.05)',
    'scroll-color': 'rgba(0, 0, 0, 0.05)',
    'thead-bg-color': '#F2F3F8', 
    'menu-bg-color': '#fff', 
    'border-color': '#E5E6EB',
    'main-font-color': '#000',
    'font-color-08': 'rgba(0, 0, 0, 0.8)',
    'font-color-06': 'rgba(0, 0, 0, 0.6)',
    'font-color-04': 'rgba(0, 0, 0, 0.4)',
    'font-color-02': 'rgba(0, 0, 0, 0.2)'
  }
}
